export default __webpack_public_path__ + "static/9-fit-7dd042728121da6a7f3068d390683fef.png";